// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// ���ڿ���������Ч
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error
  console.error = (...args) => {
    // ���� ResizeObserver ��ؾ���
    if (args[0]?.includes('ResizeObserver loop completed with undelivered notifications')) {
      return
    }
    originalError.call(console, ...args)
  }
}

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')